import React from "react";
import { RotateCw, Download, Upload, Clock } from "lucide-react";
import LocationScheduleImport from "../../utils/LocationScheduleImport";
import DefaultLocationModal from "../modals/DefaultLocationModal";
import ShiftControlModal from "../shiftControl/ShiftControlModal";
import RemotePunchModal from "../remotePunch/RemotePunchModal";
import templateFile from "../../../../Documents/Attendance_template.xlsx";
import { getTopBarButtonStyle } from "../../styles/attendanceStyles";

const ActionButtons = ({
  theme,
  isRTL,
  t,
  language,
  isRecalculating,
  canRefreshAttendance,
  canExportCsv,
  canExportTemplate,
  canImportCsv,
  canImportLocationSchedule,
  canDefaultLocation,
  canShiftControl = false,
  canRemotePunch = false,
  canScheduleTemplate,
  canApproveOvertime = false,
  overtimeApprovalRequired = false,
  forceRefreshAttendance,
  exportToCSV,
  handleImportFileChange,
  overtimePendingCount = 0,
  overtimeTotalCount = 0,
  onOvertimeClick = () => { },
}) => {
  const handleExportTemplate = () => {
    const link = document.createElement("a");
    link.href = templateFile;
    link.download = "attendance_template.xlsx";
    link.click();
  };


  return (
    <div
      style={{
        display: "flex",
        gap: "8px",
        flexWrap: "wrap",
        paddingTop: "16px",
        borderTop:
          theme === "dark"
            ? "1px solid rgba(255,255,255,0.1)"
            : "1px solid rgba(0,0,0,0.1)",
        flexDirection: isRTL ? "row" : "row",
      }}
    >
      {canRefreshAttendance && (
        <button
          onClick={forceRefreshAttendance}
          disabled={isRecalculating}
          style={{
            ...getTopBarButtonStyle(theme, isRecalculating),
            flexDirection: isRTL ? "row-reverse" : "row",
          }}
          onMouseEnter={(e) => {
            if (!isRecalculating) {
              e.currentTarget.style.background = theme === "dark"
                ? "rgba(30, 41, 59, 1)"
                : "rgba(51, 65, 85, 0.2)";
            }
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = theme === "dark"
              ? "rgba(30, 41, 59, 0.8)"
              : "rgba(51, 65, 85, 0.12)";
          }}
        >
          <RotateCw
            size={16}
            className={isRecalculating ? "animate-spin" : ""}
          />
          {isRecalculating ? t.recalculating : t.refresh}
        </button>
      )}

      {canExportCsv && (
        <button
          onClick={exportToCSV}
          disabled={false}
          style={{
            ...getTopBarButtonStyle(theme, false),
            flexDirection: isRTL ? "row-reverse" : "row",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = theme === "dark"
              ? "rgba(30, 41, 59, 1)"
              : "rgba(51, 65, 85, 0.2)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = theme === "dark"
              ? "rgba(30, 41, 59, 0.8)"
              : "rgba(51, 65, 85, 0.12)";
          }}
        >
          <Download size={16} />
          {t.exportCSV}
        </button>
      )}

      {canExportTemplate && (
        <button
          onClick={handleExportTemplate}
          disabled={false}
          style={{
            ...getTopBarButtonStyle(theme, false),
            flexDirection: isRTL ? "row-reverse" : "row",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = theme === "dark"
              ? "rgba(30, 41, 59, 1)"
              : "rgba(51, 65, 85, 0.2)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = theme === "dark"
              ? "rgba(30, 41, 59, 0.8)"
              : "rgba(51, 65, 85, 0.12)";
          }}
        >
          <Download size={16} />
          {t.exportTemplate}
        </button>
      )}

      {canImportCsv && (
        <button
          onClick={() => document.getElementById("csv-import-input").click()}
          disabled={false}
          style={{
            ...getTopBarButtonStyle(theme, false),
            flexDirection: isRTL ? "row-reverse" : "row",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = theme === "dark"
              ? "rgba(30, 41, 59, 1)"
              : "rgba(51, 65, 85, 0.2)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = theme === "dark"
              ? "rgba(30, 41, 59, 0.8)"
              : "rgba(51, 65, 85, 0.12)";
          }}
        >
          <Upload size={16} />
          {language === "ar" ? "استيراد CSV" : "Import CSV"}
          <input
            id="csv-import-input"
            type="file"
            accept=".csv,.xlsx,.xls"
            onChange={handleImportFileChange}
            disabled={false}
            style={{ display: "none" }}
          />
        </button>
      )}

      {canImportLocationSchedule && (
        <LocationScheduleImport
          theme={theme}
          language={language}
          isRTL={isRTL}
        />
      )}

      {canDefaultLocation && (
        <DefaultLocationModal
          theme={theme}
          language={language}
          isRTL={isRTL}
        />
      )}

      {canShiftControl && (
        <ShiftControlModal
          theme={theme}
          language={language}
          isRTL={isRTL}
        />
      )}

      {canRemotePunch && (
        <RemotePunchModal
          theme={theme}
          language={language}
          isRTL={isRTL}
        />
      )}

      {/* Overtime Request Button — gated by the approve_overtime feature */}
      {overtimeApprovalRequired && canApproveOvertime && (
        <button
          onClick={onOvertimeClick}
          style={{
            ...getTopBarButtonStyle(theme, false),
            flexDirection: isRTL ? "row-reverse" : "row",
            position: "relative",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background = theme === "dark"
              ? "rgba(30, 41, 59, 1)"
              : "rgba(51, 65, 85, 0.2)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background = theme === "dark"
              ? "rgba(30, 41, 59, 0.8)"
              : "rgba(51, 65, 85, 0.12)";
          }}
        >
          <Clock size={16} />
          {language === "ar" ? "طلبات الإضافي" : "Overtime Requests"}
          {overtimePendingCount > 0 && (
            <span
              style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                minWidth: "20px",
                height: "20px",
                borderRadius: "50%",
                background: "#f59e0b",
                color: "#fff",
                fontSize: "11px",
                fontWeight: 700,
                marginLeft: isRTL ? "auto" : "8px",
                marginRight: isRTL ? "8px" : "auto",
              }}
            >
              {overtimePendingCount}
            </span>
          )}
        </button>
      )}
    </div>
  );
};

export default ActionButtons;